import { CANONICAL_ORIGIN } from "../config";
import { getLocaleAlternates, getLocalizedCanonical } from "./locale-meta";

// Utility for generating canonical URLs
export function getCanonicalUrl(path: string, locale = "pt"): string {
  return getLocalizedCanonical(locale, path);
}

// Add hreflang links for internationalized pages
export function getLangAlternates(path: string): { [locale: string]: string } {
  return getLocaleAlternates(path);
}

// Generate metadata for social sharing optimization
export function getSocialMetadata(
  title: string,
  description: string,
  imagePath = "/og-image.png",
) {
  const imageUrl = `${CANONICAL_ORIGIN}${imagePath}`;

  return {
    openGraph: {
      title,
      description,
      images: [
        {
          url: imageUrl,
          width: 1200,
          height: 630,
          alt: title,
        },
      ],
      siteName: "Sendbot",
      locale: "pt_BR",
      type: "website",
    },
    twitter: {
      card: "summary_large_image",
      title,
      description,
      images: [imageUrl],
      creator: "@sendbotai",
    },
  };
}

// Keywords by page for better SEO
export const pageKeywords: Record<string, string[]> = {
  home: [
    "chatbot",
    "sendbot",
    "whatsapp",
    "atendimento automatizado",
    "ia",
    "inteligência artificial",
    "automação de vendas",
    "automação de atendimento",
    "bot para whatsapp",
    "chatbot para site",
  ],
  planos: [
    "planos sendbot",
    "preços chatbot",
    "assinatura sendbot",
    "chatbot grátis",
    "plano ilimitado chatbot",
    "conexão whatsapp bot",
    "integração whatsapp",
    "preços sendbot",
    "custo chatbot",
  ],
  suporte: [
    "suporte sendbot",
    "ajuda chatbot",
    "atendimento sendbot",
    "dúvidas chatbot",
    "contato sendbot",
  ],
};
